//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'

export default {
  name:'WestleyCroup',
  data() {
    return {
      defaultJson:{
        "stridorstem2": "无瞳孔或角膜反射",
        "loc1": "闭眼但刺痛睁眼",
        "loc3 (short)": "无跟随运动",
        "cyanosisor4": "竖起拇指或握拳等",
        "stridorstem": "脑干",
        "stridorstem2 (short)": "无瞳孔或角膜反射",
        "cwriration1 (short)": "触发呼吸机",
        "stridorstem0": "无反射（瞳孔、角膜及咳嗽）",
        "cyanosisor1 (short)": "伸展反应",
        "cyanosisor3": "对疼痛可定位",
        "cwriration2": "异常呼吸模式",
        "cwriration4 (short)": "正常呼吸",
        "cwr.": "呼吸",
        "cyanosisor2": "疼痛后屈曲反应",
        "loc2": "闭眼但大声呼唤后睁眼",
        "loc4 (short)": "听从指令",
        "cyanosisor2 (short)": "屈曲反应",
        "cyanosisor1": "伸展反应",
        "stridorstem3 (short)": "单侧瞳孔散大且固定",
        "cyanosisorTitle": "运动反应",
        "cwriration0 (short)": "呼吸暂停或机械控制",
        "cyanosisor0": "对疼痛无反应或全身肌阵挛状态",
        "stridorstem0 (short)": "无反射",
        "stridorstem3": "单侧瞳孔散大且固定",
        "loc0 (short)": "无睁眼",
        "cwriration1": "触发呼吸机或以高于呼吸机的频率呼吸",
        "loc3": "睁眼但无跟随运动",
        "E {{ loc }}  M {{ cyanosis }}  B {{ stridor }}  R {{ cwr }}": "眼睛 {{ loc }}  运动 {{ cyanosis }}  大脑 {{ stridor }}  反应 {{ cwr }}",
        "cwriration4": "正常呼吸模式",
        "stridorstem1": "无瞳孔及角膜反射",
        "stridorstemTitle": "脑干反射",
        "cyanosisor3 (short)": "定位疼痛",
        "cwriration3 (short)": "潮式呼吸",
        "stridorstem4 (short)": "瞳孔及角膜反射（+）",
        "cwrirationTitle": "呼吸",
        "loc1 (short)": "刺痛睁眼",
        "loc4": "睁眼，有跟随运动或听从指令眨眼",
        "locTitle": "眼睛反应",
        "cyanosisor4 (short)": "有意义",
        "loc0": "疼痛刺激无睁眼",
        "cwriration0": "呼吸暂停或完全依赖机械通气",
        "locs": "眼睛",
        "stridorstem1 (short)": "无瞳孔及角膜反射",
        "loc2 (short)": "大声呼唤后睁眼",
        "cyanosisor0 (short)": "无反应",
        "stridorstem4": "双侧瞳孔及角膜反射存在",
        "cyanosisor": "运动",
        "cwriration2 (short)": "异常呼吸",
        "cwriration3": "潮式呼吸模式"
      },
      form:{
        loc:'',
        cyanosis:'',
        stridor:'',
        cwr:'',
        entry:'',
      },
      hasScore:false,
      disabled:false,
      dataList:[
        {value:"0",name:'正常（包括睡眠）'},
        {value:"5",name:'定向障碍'},
      ],
      dataList2:[
        {value:"0",name:'无'},
        {value:"4",name:'激动时出现'},
        {value:"5",name:'静息时出现'},
      ],
      dataList3:[
        {value:"0",name:'无'},
        {value:"1",name:'激动时出现'},
        {value:"2",name:'静息时出现'},
      ],
      dataList4:[
        {value:"0",name:'无'},
        {value:"1",name:'轻微凹陷'},
        {value:"2",name:'中度凹陷'},
        {value:"3",name:'严重凹陷'},
      ],
      dataList5:[
        {value:"0",name:'正常'},
        {value:"1",name:'减少'},
        {value:"2",name:'显著减少'},
      ],
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        // loc + cyanosis + stridor + cwr + entry
        let result = form.loc + form.cyanosis + form.stridor + form.cwr + form.entry
        self.hasScore = true
        return String(result)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pedi/WestleyCroup.vue